jQuery(function ($) {
  $(document).ready(function () {
    var offset = 1;
    var numSlots = adminUrlAndNonce.numSlots;
    var filter_button = $(".filter-button:not(.reset)");
    var slots_filter = $(".slots-filter");
    var slots_overlay = $(".slots-overlay");
    var checkboxes = $(".slots-checkbox");
    var moreBtn = $(".see-more-casinos.show-slots")
    $(filter_button).click(function () {
      $(slots_filter).show();
      $(slots_overlay).show();
    });

    $(slots_overlay).click(function () {
      $(slots_filter).hide();
      $(slots_overlay).hide();
    });
    $(window).resize(function () {
      if ($(window).width() > 1200) {
        $(slots_filter).show();
      } else {
        if (!$(slots_overlay).is(":visible")) {
          $(slots_filter).hide();
        }
      }
    });
    $(document).on("change", ".slots-checkbox", filterSlots);

    $(".slots-filter #slots-search").on(
      "input propertychange paste",
      function () {
        search(false);
      }
    );
    $(".slots-filter .fa-search").click(function () {
      search(true);
    });
    $(".search-icon").click(function () {
      if ($(".search-icon").children(".close-icon").length > 0) {
        $("#slots-search").val("");
        search(true);
      }
    });
    $(document).on("keypress", function (e) {
      if (e.which == 13) {
        search(true);
      }
    });
    $(".slots-area .close-filter").click(function () {
      $(this).parent(".slots-area").find("p").toggle();

      if (
        $(this).attr("src") ===
        "/wp-content/themes/Casinobonusar_2019/lib/img/open-circle.svg"
      ) {
        $(this).attr(
          "src",
          "/wp-content/themes/Casinobonusar_2019/lib/img/remove-circle-outline.svg"
        );
      } else {
        $(this).attr(
          "src",
          "/wp-content/themes/Casinobonusar_2019/lib/img/open-circle.svg"
        );
      }
    });

    $(".reset").click(function () {
      clearFilters();
    });

    function search(toExit) {
      var search = $("#slots-search").val();
      $(".slot-card").each(function () {
        var title = $(this).find(".title").text();

        // console.log(title);
        // console.log(search);

        if (
          title.toLowerCase().search(search.toLowerCase()) >= 0 ||
          search === ""
        ) {
          $(this).show();
        } else {
          $(this).hide();
        }
        if ($(slots_overlay).is(":visible") && toExit) {
          $(slots_filter).hide();
          $(slots_overlay).hide();
        }

        if ($(".slot-card:visible").length == 0) {
          $(".no-slots").show();
        } else {
          $(".no-slots").hide();
        }
      });

      if (search === "") {
        $(".search-icon").html("<i class='fa fa-search pointer'></i>");
      } else {
        $(".search-icon").html(
          "<img class='close-icon' src='/wp-content/themes/Casinobonusar_2019/lib/img/close.svg'></img>"
        );
      }
      if (showReset() && $(window).width() <= 1200) {
        $(".filter-button.reset").css("display", "flex");
        $(".filter-button:not(.reset)").addClass("filter-activated");
      } else {
        $(".filter-button.reset").css("display", "none");
        $(".filter-button:not(.reset)").removeClass("filter-activated");
      }
    }

    

    function filterSlots() {
      var name_list = [];
      $(".slot-card").hide();
      $(checkboxes).each(function () {
        if (this.checked) {
          name_list.push($(this).attr("name"));
        }
      });
      if (name_list.length > 0) {
        console.log(name_list);
        for (var i = 0; i < name_list.length; i++) {
          $(".slot-card." + name_list[i]).show();
        }
      } else {
        $(".slot-card").show();
      }
      if ($(".slot-card:visible").length == 0) {
        $(".no-slots").show();
      } else {
        $(".no-slots").hide();
      }
      if (showReset() && $(window).width() <= 1200) {
        $(".filter-button.reset").css("display", "flex");
        $(".filter-button:not(.reset)").addClass("filter-activated");
      } else {
        $(".filter-button.reset").css("display", "none");
        $(".filter-button:not(.reset)").removeClass("filter-activated");
      }
    }

    function showReset() {
      var show = false;
      $(checkboxes).each(function () {
        if (this.checked) {
          show = true;
        }
      });
      var search = $("#slots-search").val();
      if (search !== "") {
        show = true;
      }

      return show;
    }

    function clearFilters() {
      $("#slots-search").val("");
      search();

      $(checkboxes).each(function () {
        $(this).prop("checked", false);
      });

      $(".filter-button.reset").css("display", "none");
      $(".filter-button:not(.reset)").removeClass("filter-activated");
    }

    // SHOW MORE SLOTS

    $(".see-more-casinos.show-slots").click(function () {
      console.log(numSlots);
      console.log(offset);
      showSpinner()
      
      // adminUrlAndNonce
      $.ajax({
        type: "post",
        url: adminUrlAndNonce.ajaxUrl,
        data: {
          action: "view_more_slots",
          numSlots: numSlots,
          offset: offset,
        },
        success: function success(_success) {
          _success = JSON.parse(_success);
          
          if (_success.slots == undefined || _success.slots == "") {
            
            blinkShowMoreBtn();
            $('.spinner').hide();
            return;
        }

          $(".slot-cards").append(_success.slots);
          // appendFilterProvider(_success.providers);
          // appendFilterThemes(_success.themes);
          checkboxes = $(".slots-checkbox");
          hideSpinner();
        },
        error: function error(_error) {
          console.log(_error);
          hideSpinner();
        },
      });
      offset++;
    });

    function appendFilterProvider(providers) {
      for (var i = 0; i < providers.length; i++) {
        var checks = $(
          "input[name*='provider-" + providers[i].replace(" ", "-") + "']"
        );

        if (checks.length == 0 && providers[i] != "" && providers[i] != null) {
          var content =
            `<p>
                          <label class="switch checkbox">
                              <input type="checkbox" class="slots-checkbox" name="provider-` +
            providers[i].replace(" ", "-") +
            `">
                              <span class="custom-check"><i class="fa fa-check checkbox-check" style="color: white"></i></span>
                          </label>
                          ` +
            providers[i] +
            `
                        </p>`;

          $(".slots-area.providers").append(content);
        }
      }
    }

    function appendFilterThemes(themes) {
      for (var i = 0; i < themes.length; i++) {
        var checks = $("input[name*='theme-" + themes[i] + "']");

        if (checks.length == 0 && themes[i] != "" && themes[i] != null) {
          var content =
            `<p>
                          <label class="switch checkbox">
                              <input type="checkbox" class="slots-checkbox" name="theme-` +
            themes[i] +
            `">
                              <span class="custom-check"><i class="fa fa-check checkbox-check" style="color: white"></i></span>
                          </label>
                          ` +
            themes[i] +
            `
                        </p>`;

          $(".slots-area.themes").append(content);
        }
      }
    }

    function showSpinner() {
      $(".spinner").addClass("spinner-active"); // load spinner animation
      moreBtn.hide();
    }

    function hideSpinner() {
      $(".spinner").removeClass("spinner-active");
      moreBtn.show();
      
    }

    function blinkShowMoreBtn(msg = "Inga Fler Spel") {
      moreBtn.fadeOut(200, function () { moreBtn.text(msg); });

      // blink effect
      for (i = 0; i < 5; i++) {
          moreBtn.fadeIn(200);
          moreBtn.fadeOut(200);
      }

      moreBtn.fadeOut(200, function () { moreBtn.text("Visa Alla Spel"); });
      moreBtn.fadeIn(200);
  }
  });
});
